(function() { 
	'use strict';

	angular.module('smb-app')
		.directive('smbIcon', IconDirective)
		.controller('smbIconController', ['$scope', 'smbIconTypes', 'smbIconDataStore', IconController]);

	var templateUrl = require('./icon.template');
	/**
	 * @ngdoc directive
	 * @name smb-app.smbIcon2
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * A component for retrieving and displaying user configurable icons. This component currently only works for
	 * SVG icons. Binary image files are not yet supported, but will be in the future.
	 *
	 * @usage
	 *
	 * <smb-icon icon-uri="https://sharebase-api/icons/document" icon-name="document" icon-type="SVG" />
	 */
	function IconDirective() {
		return {
			restrict: 'E',
			controller: 'smbIconController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				iconUri: '@',
				iconName: '@',
				iconType: '@'
			}
		};
	}

	function IconController($scope, smbIconTypes, smbIconDataStore) {
		var vm = this;
		vm.iconTypes = smbIconTypes;
		vm.iconData = null;

		var _prevUrl;

		function loadIcon() {
			smbIconDataStore.getIconData({IconUri: vm.iconUri, IconExtension: vm.iconType})
				.then(function(data) {
					vm.iconData = data;
				});
		}

		$scope.$watch('vm.iconUri', function() {
			if (_prevUrl !== vm.iconUri) {
				_prevUrl = vm.iconUri;
				loadIcon();
			}
		});

		loadIcon();
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/icon/icon.js
// module id = 88
// module chunks = 1